import http from "./httpService";

export function getBsps(type, id) {
  return http.get("/bsps/" + type + "/" + id);
}

export function getBspById(id) {
  return http.get("/bsps/" + id);
}